import React from 'react';
import { TableActionColumn, TableColumn, TableItemAction } from './models';
import { TableBody } from './table-body';
import { TableHeader } from './table-header';

export interface TableProps<T> {
  data: Array<T>;
  customClass: string;
  itemActions?: Array<TableItemAction<T>>;
  columns: Array<TableColumn<T>>;
  actionsColumn?: TableActionColumn<T>;
  selectable?: boolean;
  actionsSelectable?: boolean;
  selectedRows?: Array<number>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onSelectRow?: (val: any) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onSelectAll?: (val: any) => void;
}

export const Table = <T,>({
  data,
  itemActions,
  columns,
  actionsColumn,
  selectable,
  actionsSelectable,
  customClass,
  selectedRows,
  onSelectRow,
  onSelectAll,
}: TableProps<T>): React.ReactElement => {
  return (
    <div className={`table-responsive overflow-y-visible ${customClass}`}>
      {!data || data.length === 0 ? (
        <div className="d-flex justify-content-center flex-column align-items-center align-self-center">No data</div>
      ) : (
        <table className="table table-hover table-light table-borderless">
          <TableHeader
            onSelectAll={onSelectAll}
            selectable={selectable}
            actionsSelectable={actionsSelectable}
            allSelected={selectedRows?.length === data?.length}
            columns={columns}
            actionsColumn={actionsColumn}
            stickyHeader
            renderActions
          />
          <TableBody
            onSelectRow={onSelectRow}
            selectedRows={selectedRows}
            selectable={selectable}
            data={data}
            columns={columns}
            itemActions={itemActions}
          />
        </table>
      )}
    </div>
  );
};

Table.defaultProps = {
  customClass: '',
};
